import { Helmet } from 'react-helmet-async';
import { CONFIG } from 'src/config-global';
import Dashboard from 'src/sections/admin/dashboard';

export default function Page() {
  return (
    <>
      <Helmet>
        <title> {`Admin Dashboard - ${CONFIG.appName}`}</title>
      </Helmet>
      <Dashboard/>
    </>
  );
}